import { render, staticRenderFns } from "./teacherCourse.vue?vue&type=template&id=7304ee7c&scoped=true&"
import script from "./teacherCourse.vue?vue&type=script&lang=js&"
export * from "./teacherCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7304ee7c",
  null
  
)

export default component.exports